import type { SVGProps } from "react";
const SvgCancel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#CE2222"
      d="M14 3.209 12.791 2 8 6.791 3.209 2 2 3.209 6.791 8 2 12.791 3.209 14 8 9.209 12.791 14 14 12.791 9.209 8z"
    />
  </svg>
);
export default SvgCancel;
